import styled from "styled-components";
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";
import { mobile_medium, mobile_normal, mobile_title } from "../../const/fonts";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

export const Container = styled.div`
	background-color: ${SECONDARY};
	border: 1px solid ${PRIMARY};
	position: relative;
  width: 600px;
  overflow-x: hidden;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    padding-top: 94px;
    padding-bottom: 1rem;
    border: none;
    //overflow: hidden;
  }
`;

export const UserName = styled.div`
  text-align: center;
  font-weight: bold;
  background-color: ${DARKER};
  padding: 0.5rem;
  color: #fff;
  font-size: ${mobile_medium};
  position: relative;
  cursor: default;

  span {
    text-transform: uppercase;
  }

  @media screen and (max-width: 768px) {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 1rem;
  }
  @media screen and (max-width: 480px) {
    width: 90%;
  }
`;

export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 0;
	svg {
		font-size: 2.5rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY};
  position: relative;
  cursor: default;
  h2 {
    padding: 0.7rem;
    margin: 0 auto;
    color: ${SECONDARY};
    font-weight: 800;
  }

  @media screen and (max-width: 768px) {
    width: 80%;
    margin: 2rem auto;
    margin-bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    h2 {
      font-size: ${mobile_title};
    }
  }
  @media screen and (max-width: 480px) {
    width: 90%;
  }
`;

export const Wrapper = styled.div`
  padding: 2rem;
  min-height: 300px;
  
  @media screen and (max-width: 768px) {
    padding: 0 5rem;
    //height: calc(70%);
    //overflow-y: auto;
  }

  @media screen and (max-width: 480px) {
    //height: calc(55%);
    padding: 0 2rem;
  }

  @media screen and (max-height: 690px) {
    min-height: 200px;
    //height: calc(50%);
  }
`;

export const ButtonsContainer = styled.div`
  margin: 1rem 1rem;
  margin-left: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-right: 1rem;
  }

  @media screen and (max-width: 768px) {
    padding: 0 4rem;
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
    padding: 0 1rem;
    width: 100%;
    margin: 0;

    > div {
    justify-content: space-evenly;
    margin-right: 0;
    }
  }
`;

export const Button = styled.button`
  width: 30%;
	font-size: 0.9rem;
  font-weight: bold;
	border: ${props=> props.primary ? '1px solid transparent' : `1px solid ${PRIMARY}`};
  background-color: ${props=> props.primary ? PRIMARY : 'transparent'};
  color: ${props => props.primary ? SECONDARY : PRIMARY} ;
  box-shadow: ${props => props.primary ? BOX_SHADOW : 'none'};
  padding: 0.7rem;
	margin-top: 1.5rem;
  margin-right: ${props => !props.primary ? '1rem' : 0};
  cursor: pointer;
  transition: all .3s ease-in-out;
  
  &:hover{
    background-color: #fff;
    color: ${SECONDARY};
  }

  @media screen and (max-width: 480px) {
    margin-top: 1rem;
    width: 45%;
  }

  @media screen and (max-height: 690px) {
    margin-top: 0.5rem;
    padding: 0.5rem 0.8rem;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    color: #fff;
    font-weight: bold;
    font-size: 0.8rem;
    padding: 0.5rem;
    margin-top: 0.5rem;
  }

  select, input {
    background-color: transparent;
    border: 1px solid ${PRIMARY};
    padding: 0.5rem;
    color: #fff;
    outline: none;
    transition: all 0.3s ease;
  }

  option {
    //color: ${SECONDARY};
    background-color: ${DARKER};
  }

  input:hover, select:hover {
    border-color: #fff;
  }

  @media screen and (max-width: 768px) {
    label, input, select, input {
      font-size: ${mobile_normal};
    }
  }
`;

export const ButtonFavorito = styled.div`
  position: absolute;
  top: 0;
  right: 1rem;
  bottom: 0;

  button {
    display: flex;
    align-items: center;
    background-color: #28a745;
    color: #fff;
    border: none;
    outline: none;
    font-weight: bold;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    transition: all 0.3s ease;
    cursor: pointer;
    svg {
      font-size: 1rem;
    }
    &:hover {
      background-color: #28a74599;
    }
  }
`;

/* MODAL FAVORITOS */

export const ModalFavContainer = styled.div`
  background-color: ${DARKER};
  min-height: 300px;
  min-width: 300px;
  h3{
    padding: 0.5rem;
    color: ${DARKER};
  }

  @media screen and (max-width: 768px) {
    min-width: fit-content;
  }
`;

export const FavoritosContent = styled.div`
  padding: 1rem;
`;

export const Favorito = styled.div`
  background-color: ${DARKER};
  display: flex;
  align-items: center;
  color: #fff;
  margin: 0.5rem;
  svg {
    color: #dc3545;
    font-size: 21px;
  }
  div {
    transition: all 0.3s ease;
    overflow: hidden;
    min-height: 40px;
    cursor: pointer;
  }
  div.info {
    padding: 0.5rem;
    font-weight: bold;
    padding-left: 0.25rem;
    text-align: center;
    border: 1px solid ${PRIMARY};
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    span {
      font-size: 0.8rem;
    }
  }
  div.trash {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 0.25rem;
    border-top: 1px solid ${PRIMARY};
    border-bottom: 1px solid ${PRIMARY};
    border-left: 1px solid ${PRIMARY};
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;;
  }
  .info:hover {
    background-color: #fff;
    color: ${DARKER};
  }
  .trash:hover {
    background-color: #dc3545;
    svg {
      color: #fff;
    }
  }
`;

export const ButtonCloseFav = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
`;

export const Form = styled.form`
  padding: 3rem;

  @media screen and (max-height: 700px) {
    padding: 1rem 3rem;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
    padding: 0rem 3rem;
    //height: calc(80%);
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    padding: 0rem 2rem;
   // height: calc(80%);

   // overflow-y: auto;
  }

  @media screen and (max-height: 690px) {
    //height: calc(75%);
  }
`;
export const ExpandIcon = styled(ArrowDropDownIcon)`
  color: ${PRIMARY};
`;

export const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  border-radius: 0 !important;

  ::before {
    opacity: 0 !important;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 0;
  }
`;

export const AccordionHeader = styled(AccordionSummary)`
  color: #fff !important;
  font-weight: bold !important;
  margin: 0 auto !important;
  border-bottom: 1px solid ${PRIMARY} !important;

  div.title {
    display: flex;
    flex-direction: column;
    span {
      font-size: 0.7rem !important;
    }
  }

  .subtitle {
    padding: 0.5rem 0;
  }
`;

export const AccordionContent = styled(AccordionDetails)`
  background: transparent;
  color: #fff;
  padding: 0 !important;

  > div.pagoEfectivo {
    padding: 1rem 2rem !important;
    h3,
    h4 {
      margin: 0.5rem 0;
    }
    div {
      padding: 0.25rem;
      font-size: 0.9rem;
      color: #ccc;
    }
    .bancos {
      font-size: 0.8rem;
    }
    img {
      width: 100%;
      margin: 0.5rem 0;
    }
    div.button {
      text-align: center;
    }
  }
`;
